/**
 * Semantic Typography Tokens — CSS variable references.
 */

export const fontSize = {
  /** 12px */
  xs: "var(--fs-xs)",
  /** 13px */
  sm: "var(--fs-sm)",
  /** 14px */
  base: "var(--fs-base)",
  /** 16px */
  lg: "var(--fs-lg)",
  /** 18px */
  xl: "var(--fs-xl)",
  /** 20px */
  "2xl": "var(--fs-2xl)",
  /** 24px */
  "3xl": "var(--fs-3xl)",
  /** 32px */
  "4xl": "var(--fs-4xl)",
  /** 40px (display) */
  "5xl": "var(--fs-5xl)",
} as const;

export const controlFontSize = {
  default: "var(--fs-control)",
  sm: "var(--fs-control-sm)",
} as const;

export const fontWeight = {
  light: "var(--fw-light)",
  normal: "var(--fw-normal)",
  medium: "var(--fw-medium)",
  semibold: "var(--fw-semibold)",
  bold: "var(--fw-bold)",
} as const;

export const lineHeight = {
  /** 1 — buttons, single-line elements */
  none: "var(--lh-none)",
  /** 1.1 — for data labels, compact UI */
  compact: "var(--lh-compact)",
  /** 1.2 — headings */
  tight: "var(--lh-tight)",
  /** 1.3 — between tight and normal (cards, banners) */
  snug: "var(--lh-snug)",
  /** 1.5 — body text, general use */
  normal: "var(--lh-normal)",
  /** 1.6 — relaxed reading */
  relaxed: "var(--lh-relaxed)",
  /** 1.75 — long-form reading */
  loose: "var(--lh-loose)",
} as const;

export const letterSpacing = {
  none: "var(--ls-none)",
  /** 0.01em — subtle tracking */
  micro: "var(--ls-micro)",
  tight: "var(--ls-tight)",
  normal: "var(--ls-normal)",
  /** 0.08em — uppercase text */
  caps: "var(--ls-caps)",
  wide: "var(--ls-wide)",
} as const;
